import type { IListenViewModel } from 'core'

export function useRecordingData(id: string) {
  return useAsyncData<IListenViewModel>(`listen:${id}`, () => api.audio.getPublic(id), {
    getCachedData(key, nuxt) {
      const data = nuxt.isHydrating ? nuxt.payload.data[key] : nuxt.static.data[key]

      if (data)
        return data

      // Return form cache if synced
      // Client side
      if (import.meta.client) {
        const { settings, user, isSynced } = useSession()
        const db = useAudioFolders()
        const audio = db.getItem(id)

        if (audio && isSynced) {
          console.log(`${id} recording data loaded from cache`)

          return {
            audio,
            user,
            settings: {
              name: (audio.isReply ? audio.email : user.name) || 'Someone',
              ...settings.defaults,
              ...settings.getAppSettings('listenPage')
            }
          }
        }
      }
    }
  })
}

/** Tracks view event for an audio */
export function trackAudioPageListen(id: string) {
  onMounted(() => {
    api.audio.trackListen(id)
    track('Viewed Vocal Link', { uuid: id })
  })
}

/** Tracks view event for a meeting page */
export function trackAudioPageMeeting(id: string) {
  onMounted(() => {
    api.audio.trackListen(id)
    track('Viewed Vocal Meeting Link', { uuid: id })
  })
}
